import { cn } from '@massilia/ui'
import { type ReactNode } from 'react'

/**
 * En-tête d'étape du paiement : pastille numérotée + titre, contenu en dessous.
 * Volontairement sans carte : les choix qu'elle contient portent déjà leur propre
 * bordure, une carte englobante créerait des cadres imbriqués.
 */
interface StepCardProps {
  className?: string
  children: ReactNode
  step: number
  subtitle?: string
  title: string
}

export function StepCard({ className, children, step, subtitle, title }: StepCardProps) {
  return (
    <section className={cn('flex w-full flex-col gap-4', className)}>
      <div className="flex items-start gap-3">
        <div
          aria-hidden
          className="bg-brand-600 mt-px flex size-6 shrink-0 items-center justify-center rounded-full text-[13px] font-semibold text-white"
        >
          {step}
        </div>
        <div className="flex flex-col gap-0.5">
          <h2 className="text-gray-light-900 text-base leading-6 font-semibold">{title}</h2>
          {subtitle && <p className="text-gray-light-600 text-xs">{subtitle}</p>}
        </div>
      </div>
      {children}
    </section>
  )
}
